/**
 *
 * PortalContent
 *
 * @version 1.0.0
 * @author Vittorio
 * @since 19-Oct-2022
 */

import React from 'react';
import PropTypes from 'prop-types';
import PortalLoader from 'Components/PortalLoader';
import { Grid } from '@mui/material';
import style from './PortalContent.scss';

const PortalContent = (props) => (
	<Grid className={`${style.content} ${props.className}`}>
		{props && props.isLoading ? (
			<Grid className={style.loaderContainer}>
				<PortalLoader />
			</Grid>
		) : (
			<>{props.children}</>
		)}
	</Grid>
);

PortalContent.propTypes = {
	// Add here some propTypes
	// and set a minimal description i.e.
	/** Description of prop "baz". */
	children: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
	className: PropTypes.string,
	isLoading: PropTypes.bool,
};

PortalContent.defaultProps = {
	// Add here some default propTypes values
	className: '',
	isLoading: false,
};

export default PortalContent;
